import React from 'react';
import { Box, Typography } from '@mui/material';

// Standard page header: H1 (24/600/32) + optional subtitle + optional actions.
// Sticky just below the fixed app bar (64px) with an opaque background so the
// title can never be overlapped/clipped while the page scrolls under the bar.
export default function PageHeader({ title, subtitle, actions }) {
  return (
    <Box
      sx={{
        mb: 3,
        position: 'sticky',
        top: 64, // pins directly beneath the fixed app bar (Toolbar height) while scrolling
        zIndex: 1,
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', md: 'center' },
        gap: 2,
      }}
    >
      <Box>
        <Typography
          variant="h1"
          sx={{ fontSize: '24px', fontWeight: 600, lineHeight: '32px', color: 'grey.900' }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>{actions}</Box>}
    </Box>
  );
}
